import { render, staticRenderFns } from "./WhereIsMyBook.vue?vue&type=template&id=3b6e07b6&scoped=true"
import script from "./WhereIsMyBook.vue?vue&type=script&lang=js"
export * from "./WhereIsMyBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6e07b6",
  null
  
)

export default component.exports